import { inject, Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Logger } from "../../../harmony/core";
import { UserRole } from "../models/user";
import {
  LocalStorageService,
  StorageKeys,
  StorageUserItem,
} from "../services/local-storage.service";

@Injectable()
export class GtmFactory {
  private readonly logger = inject(Logger).withTag("GtmFactory");
  private readonly localStorageService = inject(LocalStorageService);

  public getGtmId(): string {
    if (this.localStorageService.get(StorageKeys.IsUserEmployee)) {
      this.logger.info("Internal");
      return environment.google.internalTagManagerId;
    }

    const user = this.localStorageService.getParsed<StorageUserItem>(
      StorageKeys.User,
    );

    if (
      user?.userRole === UserRole.Admin ||
      user?.userRole === UserRole.ExternalPartnerAdmin
    ) {
      this.logger.info("Internal");
      return environment.google.internalTagManagerId;
    }

    this.logger.info("Customers");
    return environment.google.customersTagManagerId;
  }
}
